import { HttpService } from "../../modules/shared/services/http.service";
import { 
  VideoCallManagement, 
  VideoCallManagementCreateDto, 
  VideoCallManagementUpdateDto,
  VideoCallManagementResponse,
  VideoCallManagementLatestResponse
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Get latest video call management
export const getLatestVideoCallManagement = async (): Promise<VideoCallManagementLatestResponse> => {
  const response = await HttpService.get("api/v1/video-call-managements/latest", true, { "x-custom-lang": "en" });
  return response;
};

// Get all video call management with pagination
export const getVideoCallManagement = async (query?: Record<string, string | number | boolean>): Promise<VideoCallManagementResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/video-call-managements${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get video call management by ID
export const getVideoCallManagementById = async (id: string): Promise<VideoCallManagement> => {
  const response = await HttpService.get(`api/v1/video-call-managements/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Create new video call management
export const createVideoCallManagementAction = async (data: VideoCallManagementCreateDto): Promise<VideoCallManagement> => {
  const response = await HttpService.post("api/v1/video-call-managements", data, headers, true);
  return response;
};

// Update video call management
export const updateVideoCallManagementAction = async (id: string, data: VideoCallManagementUpdateDto): Promise<VideoCallManagement> => {
  const response = await HttpService.patch(`api/v1/video-call-managements/${id}`, data, headers, true);
  return response;
};

// Delete video call management
export const deleteVideoCallManagementAction = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/video-call-managements/${id}`, { "x-custom-lang": "en" }, true);
};
